import { __rest } from "tslib";
import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxOptionType } from 'antd/lib/checkbox';
import classnames from 'classnames';
import './siriusCheckbox.scss';
export const prefixCls = 'sirius-checkbox-ehc';
const Component = (props, ref) => {
    const { className = '', children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement(Checkbox, Object.assign({ className: classnames(prefixCls, className) }, rest, { ref: ref }), children));
};
const Group = (props) => {
    const { className = '', children } = props, rest = __rest(props, ["className", "children"]);
    return (React.createElement("span", { className: classnames(prefixCls, className) },
        React.createElement(Checkbox.Group, Object.assign({}, rest), children)));
};
const CheckboxRef = React.forwardRef(Component);
const SiriusCheckbox = CheckboxRef;
SiriusCheckbox.Group = Group;
export { CheckboxOptionType };
export default SiriusCheckbox;
